import MappingTabs from './MappingTabs'
export default MappingTabs



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/index.js